import Filter from './Filter';

export default Filter;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductList/Filter/index.js